import React from 'react';

export const SubNavBar = React.memo(({ visibile = true, children }) => {
  if (!visibile) return null;

  return <div className="header-sub-navbar position-fixed w-100 border-bottom border-gray-300 px-3 py-1 bg-blue-100">{children}</div>;
});
